import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { SITE_URL } from '../config';

/**
 * Page-level SEO, the React way — same library (react-helmet-async) and same
 * pattern the host app already uses, so once integrated it renders through the
 * host's existing <HelmetProvider> with no extra wiring.
 *
 *   <Seo title="Pricing | TeamGrid™" description="…" />
 *
 * Canonical defaults to SITE_URL + current path; pass `canonical` to override,
 * or `noindex` for thank-you / token pages that must stay out of search.
 */
export default function Seo({ title, description, canonical, image, noindex = false, children }) {
  const { pathname } = useLocation();
  const url = canonical || `${SITE_URL}${pathname === '/' ? '' : pathname}`;
  const img = image || `${SITE_URL}/assets/img/era_brain2.jpeg`;

  return (
    <Helmet prioritizeSeoTags>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={url} />
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : null}

      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={img} />
      {children}
    </Helmet>
  );
}
